// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  mr_product_style_code: yup.string().label("Style code").required(),
  mr_product_style_name: yup.string().label("Style name").required()
})